import { API_BASE_URL } from "../Config";
import { getCsrfToken } from "./csrf";

export async function sendEmail(
  cart,
  clientName,
  clientSurname,
  clientEmail,
  shippingCost,
  totalPriceWithShippingCost,
  deliveryAddress,
  languageLocale,
  orderId
) {
  try {
    const csrfToken = getCsrfToken();

    const response = await fetch(`${API_BASE_URL}/api/send-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      body: JSON.stringify({
        cart,
        clientName,
        clientSurname,
        clientEmail,
        shippingCost,
        totalPriceWithShippingCost,
        deliveryAddress,
        languageLocale,
        orderId,
      }),
      credentials: "include",
    });

    return await response.json();
  } catch (error) {
    console.error("Erro ao enviar o email:", error);
    return { status: "error", error };
  }
}
